<template>
  <div class="full-page">
    <div class="curriculum_main">
      <span class="curriculumPage_span"></span>
      <div class="curriculumPage" ref="middle_page">
        <div class="primarylists list-mobile"></div>
        <div class="height_page curriculum_components">
          <keep-alive>
            <component :is="item" :outlineInfo="this.outlineInfo" :userId="this.userId"  ref="child" @change-outline="changeOutline" @passvalue="passvalues"></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import video_item from '../../components/curriculum/learn.vue'
  import read_item from '../../components/curriculum/read.vue'
  export default {
    name: 'lesson',
    components: {
      video_item,
      read_item
    },
    data() {
      return {
        courseName: null, //课程名称
        userId: null, //用户id
        item: null, //video_item:课程播放，read_item:课程阅读
        outlineInfo: {},
        courseInfo: null,
        courseOutlineId: null,
        index: 0,
        listlength:null, //列表长度,
        datalist:[],  //课程资源列表,
        isPdf:null, //判断是否为pdf
        chapterNameFlag:null,
      }
    },
    created() {
      Promise.resolve().then(
        () => {
          //执行自动登录
          return this.$autoLogin().then(
            () => {
              this.userId = window.sessionStorage.getItem("id");
            }, () => {
              //无操作
              this.userId = "tourist";
            }
          )
        }
      ).then(
        () => {
          document.documentElement.scrollTop = 0;
          this.outlineInfo = eval('(' + this.$route.query.outlineInfo + ')');
          this.outlineInfo = JSON.parse(JSON.stringify(this.outlineInfo));
          if (this.outlineInfo != undefined && this.outlineInfo != null) {
            this.chapterNameFlag = this.outlineInfo.secondChapterName;
          }
          //获取课程相关信息
          this.$api.post("/courseStudy/getCourseInfo", {
            "id": this.outlineInfo.courseId
          }).then(
            (response) => {
              this.courseInfo = response.data;
            }
          )
          // if (this.outlineInfo) {
          // 	//判断是否购买该课程
          // 	this.$api.post("/courseStudy/getOutlineCountByUserIdCourseId", {
          // 		"courseId": this.outlineInfo.courseId,
          // 		"createBy": this.userId
          // 	}).then(
          // 		(response) => {
          // 			if (response.data == 0) {
          // 				this.outlineInfo.isBuy = 0;
          // 			} else {
          // 				this.outlineInfo.isBuy = 1;
          // 			}
          // 		}
          // 	)
          // 	if (this.outlineInfo.type === "1") {
          this.item = 'video_item'
          // 	} else if (this.outlineInfo.type === "2") {
          // 		this.item = 'read_item'
          // 	} else {
          // 		this.$router.push({
          // 			path: "/home/task/answer",
          // 			query: {
          // 				outlineInfo: JSON.stringify(this.outlineInfo)
          // 			}
          // 		})
          // 	}
          // } else {
          // 	//如果没有资料类型跳回首页
          // 	this.$router.push({
          // 		path: "home/index"
          // 	})
          // }
        }
      )
    },
    methods: {
      downloadFile: function() {
        if (this.userId == 'tourist') {
          this.$el_alert_type(window.vm.$i18n.t('js.loginPlease'), 'warning');
          return;
        }
        this.$refs.child.downloadFile();
      },
      downloadOriginalFile: function() {
        if (this.userId == 'tourist') {
          this.$el_alert_type(window.vm.$i18n.t('js.loginPlease'), 'warning');
          return;
        }
        this.$refs.child.downloadOriginalFile();
      },
      passvalues: function(chapterName){
        this.chapterNameFlag = chapterName;
      },
      changeOutline: function(outlineInfo) {
        this.outlineInfo.topId = outlineInfo.topId;
        this.outlineInfo.secondId = outlineInfo.secondId;
        this.outlineInfo.thirdId = outlineInfo.thirdId;
        this.outlineInfo.type = outlineInfo.type;
        this.outlineInfo.secondChapterName = outlineInfo.secondChapterName;
        if (this.outlineInfo.type === "1") {
          this.item = 'video_item'
        } else if (this.outlineInfo.type === "2") {
          this.item = 'read_item'
        } else {
          this.$router.push({
            path: "/home/task/answer",
            query: {
              outlineInfo: JSON.stringify(this.outlineInfo)
            }
          })
        }
      },
      goto_Aicourse: function() {
        this.$router.push({
          name: 'Aicourse',
          query: {
            buyCourseId: JSON.stringify(this.courseInfo.id),
            buyCollegeId: JSON.stringify(this.courseInfo.collegeId)
          }
        });
      },
      goto_lesson: function() {
        let outlineInfo = {
          "courseId": this.outlineInfo.courseId,
          "courseName": this.outlineInfo.courseName
        };
        this.$router.push({
          path: "/home/curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo)
          }
        })
      }
    },
    mounted() {
      //获取设备屏幕的高度
      const h = document.body.clientHeight - 349
      // this.$refs.middle_page.style.minHeight = h + "px";
    }
  }
</script>

<style scoped="scoped">
  .curriculum_page {
    width: 100%;
    background: white;
    display: flex;
    position: relative;
    padding-top: 10px;
  }

  .curriculum_main {
    width: 100%;
    height: 100%;
    min-height: 600px;
    /*padding-bottom: 50px;*/
  }

  .curriculumPage {
    min-width: 1200px;
    margin: 0 auto;
    padding-top: 70px !important;
    padding-bottom: 30px;
    /* position: relative; */
    min-height: 100vh;
    display: block;
    box-shadow: none !important
  }
  .curriculumPage_span{
    /* position: absolute; */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .curriculumPage_top {
    width: 90%;
    min-width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .curriculumPage_top p {
    line-height: 34px;
    text-align: left;
    color: #0071c5;
    font-size: 20px;
    /* font-family: lato-light, lato, sans-serif; */
    text-indent: 10px;
    font-weight: 400;
    margin-top: 4px;
    font-family: lato, sans-serif;
    font-weight: 300;
    font-style: normal;
  }

  .curriculumPage_top2 p {
    text-indent: 50px !important;
  }

  .curriculumPage_top p:first-child {
    margin-top: 0px;
    font-size: 30px;
    /* font-family: lato-light,lato,sans-serif; */
    font-family: lato, sans-serif;
    font-weight: 300;
    font-style: normal;
    text-transform: uppercase;
    color: #333131;
  }

  .curriculumPage_top .download {
    /* width: 98px; */
    float: right;
    margin-top: -60px;
    text-align: center;
    cursor: pointer;
  }

  .curriculumPage_top .download p {
    width: auto;
    font-size: 12px;
    color: rgb(250, 250, 250);
    /* font-family: museo-slab-w01-100, serif; */
    text-align: center;
    text-indent: unset !important;
    transform: scale(0.9);
    -webkit-transform: scale(0.9);
    line-height: 23px;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
    transition:0.5s ease;
  }
  .curriculumPage_top .download p:hover{
    color:#D0D0D0;
    transition:0.5s ease;
  }

  .curriculumPage_top .download svg {
    width: 28px;
    height: 31px;
    fill: rgba(232, 230, 230, 1);
    transition:0.5s ease;
  }
  .curriculumPage_top .download svg:hover{
    fill: #D0D0D0;
    transition:0.5s ease;
  }

 

</style>



// WEBPACK FOOTER //
// src/views/curriculum/lesson.vue